<template>
    <div>
        <v-popover popoverClass="lg-popover" :placement="placement">
            <span class="buyer-offer-comments pointer">{{companyInfo.companyName}}</span>
            <div slot="popover" class="p-20 al-left">
                <div class="pb-5">
                    <md-icon class="md-primary">room</md-icon>
                    <span class="pl-10">{{ companyInfo.companyAddress ? companyInfo.companyAddress : "—" }}</span>
                </div>
                <div class="pb-5">
                    <md-icon class="md-primary">email</md-icon>
                    <span class="pl-10" v-if="companyInfo.contactEmailAddress">
                        <a :href="'mailto:' + companyInfo.contactEmailAddress">{{ companyInfo.contactEmailAddress }}</a>
                    </span>
                    <span class="pl-10" v-if="!companyInfo.contactEmailAddress">—</span>
                </div>
                <div class="pb-5">
                    <md-icon class="md-primary">person</md-icon>
                    <span class="pl-10">{{ companyInfo.contactName ? companyInfo.contactName : "—" }}</span>
                </div>
                <div class="pb-5">
                    <md-icon class="md-primary">phone</md-icon>
                    <span class="pl-10">{{ companyInfo.contactPhoneNumber ? companyInfo.contactPhoneNumber : "—" }}</span>
                </div>
            </div>
        </v-popover>
    </div>
</template>

<script>

export default {
    name: "CompanyInfoPopup",
    //props: ["companyInfo", "placement"],
    props: {
        companyInfo: Object,
        placement: {
            type: String,
            default: 'left'
        }
    }
}
</script>